module.exports = __webpack_public_path__ + "media/images/athletes/3463-b68a1a2ff3f04e4a52fdb54c615c060b.png";